import React, { Component } from "react";
import { Modal } from "antd";

import server from "../../../axios/server";

class ParkGateQR extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feeRules: [],
    };
  }
  render() {
    const { visible, onCancel, editData } = this.props;
    return (
      <Modal
        visible={visible}
        title="道闸小程序码"
        maskClosable={true}
        onCancel={onCancel}
        footer={null}
      >
        <img
          alt="图片"
          src={`${server.httpServerUrl}/getWxQrCode?wxApp=mall&scene=${editData.gateNo}&width=2000&page=pages%2Fbarrier%2FticketCode`}
          style={{ width: "100%" }}
        />
      </Modal>
    );
  }
}

export default ParkGateQR;
